// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { IMAGE_URL, REACT_APP_API_PORT } from "../../Api";
// import axios from "axios";
// import Loader from "../Loader";
// import { FiBell, FiSearch, FiUser } from "react-icons/fi"; // Added icons
// import { getDecryptedData } from "../../config/crypto";
// import { CgProfile } from "react-icons/cg";
// import NotificationPopup from "./NotificationPopup";
// const SiteHeader = () => {
//   const user = getDecryptedData("user")
//   const [userData, setuserData] = useState([]);
//   const [data, setData] = useState([]);
//   const [logo, setLogo] = useState([]);
//   const [isLoading, setisLoading] = useState(false);
//   const [isFixed, setIsFixed] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY === 0) {
//         setIsFixed(true);
//       } else {
//         setIsFixed(false);
//       }
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);


//   const getData = async () => {
//     try {
//       setisLoading(true);
//       const res = await axios.get(
//         `${REACT_APP_API_PORT}user/homepage/header-menu-details`
//       );
//       setisLoading(false);
//       if (res.data.status) {
//         setData(res.data.data);
//       }
//       if (res.data.logo) {
//         setLogo(res.data.logo);
//       }
//     } catch (err) {
//       setisLoading(false);
//       console.log(err);
//     }
//   };


//   const getUserData = async () => {
//     try {
//       setisLoading(true);
//       const token = getDecryptedData('token')
//       const res = await axios.get(
//         `${REACT_APP_API_PORT}user/auth/getprofile`, {
//         headers: {
//           'Content-Type': 'application/json',
//           'x-access-token': token
//         }
//       }
//       );
//       setisLoading(false);
//       if (res.data.status) {
//         setuserData(res.data.data);
//       }

//     } catch (err) {
//       setisLoading(false);
//       console.log(err);
//     }
//   };


//   useEffect(() => {
//     getData();
//     getUserData()
//   }, []);




//   return (
//     <>
//       <Loader isLoading={isLoading} />
//       <header
//         className="sticky top-0 z-20 bg-background-back2 shadow py-4 text-white"
//         role="banner">
//         <div className="container max-w-[80rem] mx-auto flex items-center justify-between px-4">

//           <div className="flex gap-10">
//             {/* Logo Section */}
//             <div id="site-logo" className="flex-shrink-0" title="Next Future AI">
//               <Link to="/" className="custom-logo-link" rel="home">
//                 <img
//                   src={IMAGE_URL + logo.image || "/images/NFA-Logo.png"}
//                   onError={(e)=>e.target.src="/images/NFA-Logo.png"}
//                   alt="NFA Logo"
//                   className="h-10"
//                 />
//               </Link>
//             </div>

//             {/* Desktop Navigation (Hidden on mobile) */}
//             <nav
//               className="hidden lg:flex items-center space-x-6 text-[15px] uppercase font-medium"
//               role="navigation"
//             >
//               {data &&
//                 data.map((item) => (
//                   <Link to={item?.pageurl} className="hover:text-blue-500" key={item._id}>
//                     {item?.menu_name}
//                   </Link>
//                 ))}
//             </nav>
//           </div>

//           {/* Desktop Login/Signup (Hidden on mobile) */}
//           {
//             (user) ?
//               <>
//                 {/* <Link to="/my-profile" className="hover:text-blue-500 hidden lg:block" >
//             <CgProfile />  My Profile
//             </Link> */}


//                 {/* <div className="flex gap-2 items-center ">
//                   <Link to="/notifications123" className="hidden lg:block">
//                     <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
//                   </Link>
//                   <Link to="/my-profile" className="hover:text-blue-500 hidden lg:flex items-center gap-2">
//                     <CgProfile className="text-xl w-7 h-7" />
//                   </Link>
//                 </div> */}

//                 <div className="flex gap-3 items-center relative">
//                   {/* <Link to="/notifications" className="hidden lg:block relative">
//                     <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
//                     <span className="absolute -top-3 -right-2 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
//                       5
//                     </span>
//                   </Link> */}
//                   <div className="hidden lg:block relative top-1">
//                     <NotificationPopup />
//                   </div>
//                   {
//                     (userData && userData?.image)
//                       ?
//                       <Link to="/my-profile">
//                         <img src={IMAGE_URL + userData?.image || '/favicon.png'}
//                           onError={(e) => e.target.src = '/favicon.png'}
//                           className="w-8 h-8 rounded-full border shadow hidden lg:block" title="Profile" />
//                       </Link>
//                       :
//                       <Link to="/my-profile" className="hover:text-blue-500 hidden lg:flex items-center gap-2">
//                         <CgProfile className="text-xl w-7 h-7" />
//                       </Link>
//                   }


//                 </div>



//               </>
//               :
//               <>
//                 <div className="hidden lg:flex items-center space-x-4">
//                   {/* <Link to="/login" className="hover:text-blue-500">
//                     Login
//                   </Link> */}
//                   <Link
//                     to="/login"
//                     className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-back2 bg-background-primary transition text-[15px] font-bold uppercase"
//                   >
//                     Login
//                   </Link>
//                 </div>
//               </>
//           }


//           {/* Mobile Right-side Icons (Notification, Search, User) */}
//           <div className="lg:hidden flex items-center space-x-4">
//             {/* <Link to="/notifications">
//               <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
//             </Link> */}
//             {/* <Link to="/search">
//               <FiSearch className="text-white w-6 h-6 hover:text-blue-500" />
//             </Link> */}

//             {
//               (user) ? <div className="flex items-center gap-3">
//                 <div className=" lg:hidden relative top-0.5">
//                   <NotificationPopup />
//                 </div>
//                 {
//                   (userData && userData?.image) ?
//                     <Link to="/my-profile">
//                       <img src={IMAGE_URL + userData?.image} className="w-8 h-8 rounded-full border shadow" title="Profile" />
//                     </Link>
//                     :
//                     <Link to="/my-profile">
//                       <FiUser className="text-white w-8 h-8 hover:text-blue-500" title="Profile" />
//                     </Link>
//                 }

//               </div>
//                 :
//                 <>
//                 {/* <Link to="/login">
//                   <FiUser className="text-white w-8 h-8 hover:text-blue-500" title="Profile" />
//                 </Link> */}
//                 <Link
//                     to="/login"
//                     className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-back2 bg-background-primary transition text-[15px] font-bold uppercase"
//                   >
//                     Login
//                   </Link>
//                 </>
//             }

//           </div>
//         </div>
//       </header>
//     </>
//   );
// };

// export default SiteHeader;


import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IMAGE_URL, REACT_APP_API_PORT } from "../../Api";
import axios from "axios";
import Loader from "../Loader";
import { FiBell, FiEdit, FiFileText, FiInfo, FiLogOut, FiSearch, FiUser } from "react-icons/fi"; // Added icons
import { getDecryptedData, removeStoredData } from "../../config/crypto";
import { CgProfile } from "react-icons/cg";
import NotificationPopup from "./NotificationPopup";
import { FaCrown, FaRobot } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import Avatar from "react-avatar";
import { BiSolidOffer } from "react-icons/bi";
import { createPortal } from "react-dom";

const SiteHeader = () => {
  const navigate = useNavigate()
  const user = getDecryptedData("user")
  const [userData, setuserData] = useState([]);
  const [data, setData] = useState([]);
  const [logo, setLogo] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isFixed, setIsFixed] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const drawerRef = useRef(null);
  const location = useLocation();
  const currentPath = location.pathname;
// const showAnnouncement = location.pathname === "/home-new";
  const toggleDrawer = (e) => {
    e.stopPropagation();
    setShowDrawer((prev) => !prev);
  };

  const closeDrawer = () => {
    console.log("Closing drawer");
    setShowDrawer(false);
  };

  const handleLogout = async (event) => {
    console.log("User logged out");
    // await signOut(auth);
    setShowLogoutConfirm(false);
    removeStoredData("user");
    removeStoredData("token");
    setShowDrawer(false)
    navigate("/");
  };


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const getData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/header-menu-details`
      );
      setisLoading(false);
      if (res.data.status) {
        setData(res.data.data);
      }
      if (res.data.logo) {
        setLogo(res.data.logo);
      }
    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };


  const getUserData = async () => {
    try {
      setisLoading(true);
      const token = getDecryptedData('token')
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/auth/getprofile`, {
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token
        }
      }
      );
      setisLoading(false);
      if (res.data.status) {
        setuserData(res.data.data);
      }

    } catch (err) {
      setisLoading(false);
      console.log(err);
    }
  };


  useEffect(() => {
    getData();
    getUserData()
  }, []);

const getPathname = (url) => {
    try {
      return new URL(url).pathname || "/";
    } catch (err) {
      console.warn("Invalid URL:", url);
      return "/";
    }
  };


  return (
    <>
      <Loader isLoading={isLoading} />
      {/* {showAnnouncement && (  */}
  <div className="announcement-bar">
    <div className="announcement-track">
      <span>🚀 Live AI Workshops</span>
      <span>💎 Exclusive AI Membership (30 % OFF)</span>
      <span>🎓 Professional AI Training (50 % OFF)</span>
      <span>📚 Certified AI Courses (50 % OFF)</span>

      {/* duplicate for smooth loop */}
      <span>🚀 Live AI Workshops</span>
      <span>💎 Exclusive AI Membership (30 % OFF)</span>
      <span>🎓 Professional AI Training (50 % OFF)</span>
      <span>📚 Certified AI Courses (50 % OFF)</span>

      {/* duplicate for smooth loop */}
      <span>🚀 Live AI Workshops</span>
      <span>💎 Exclusive AI Membership (30 % OFF)</span>
      <span>🎓 Professional AI Training (50 % OFF)</span>
      <span>📚 Certified AI Courses (50 % OFF)</span>
    </div>
  </div>
{/* )} */}


     <header
  className="
    fixed left-0 w-full z-20
    glass
    text-white
    shadow-lg
    py-3            /* 👈 padding bada di */
  "
  role="banner"
  //style={{ top: showAnnouncement ? "40px" : "0px" }}
  style={{ top: "40px" }}
>

     {/* <header
        className="fixed top-0 left-0 w-full z-20 bg-[#000000d6] shadow py-4 text-white "
        role="banner"> */}

        <div className="container max-w-[80rem] mx-auto flex items-center justify-between px-4">

          <div className="flex gap-10">
            {/* Logo Section */}
            {/* <div id="site-logo" className="flex-shrink-0" title="Next Future AI">
              <Link to="/" className="custom-logo-link" rel="home">
                <img
                  src={IMAGE_URL + logo.image || "/images/NFA-Logo.png"}
                  onError={(e) => e.target.src = "/images/NFA-Logo.png"}
                  alt="NFA Logo"
                  className="h-10"
                />
              </Link>
            </div> */}
            <div id="site-logo" className="flex-shrink-0">
            <Link to="/" className="flex items-center gap-3" rel="home">

              {/* NFA Badge */}
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-black font-bold">
                NFA
              </div>

              {/* Brand Name */}
              <h3 className="text-lg sm:text-xl font-extrabold tracking-wide text-white">
                NEXT FUTURE{" "}
                <span className="text-[#f55fff]">AI</span>
              </h3>

            </Link>
          </div>


            {/* Desktop Navigation (Hidden on mobile) */}
            {/* <nav
              className="hidden lg:flex items-center space-x-6 text-[15px] font-medium"
              role="navigation"
            >
              {data &&
                data.map((item) => (
                  <Link to={getPathname(item?.pageurl)} className="hover:text-blue-500" key={item._id}>
                    {item?.menu_name}
                  </Link>
                ))}
            </nav> */}
            <nav
              className="
                hidden lg:flex
                items-center space-x-6
                text-[15px] font-medium
                absolute left-1/2 -translate-x-1/2
                top-1/2 -translate-y-1/2
              "
              role="navigation"
            >

            {/* Dynamic Menu */}
            {data &&
              data.map((item) => (
                <Link
                  key={item._id}
                  to={getPathname(item?.pageurl)}
                  className="text-[#ffffffcc] hover:text-white transition"
                >
                  {item?.menu_name}
                </Link>
              ))}

            {/* MORE DROPDOWN */}
            <div className="relative group">
              <button
                className="flex items-center gap-1 text-[#ffffffcc] hover:text-white transition"
              >
                MORE
                <svg
                  className="w-4 h-4 transition-transform group-hover:rotate-180"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
              </button>

              {/* DROPDOWN MENU */}
              <div
                className="
                  absolute right-0 mt-3 w-48
                  rounded-xl border border-white/10
                  bg-black/90 backdrop-blur-xl
                  shadow-xl
                  opacity-0 invisible
                  group-hover:opacity-100 group-hover:visible
                  transition-all duration-200
                  z-50
                "
              >
                {/* <Link
                  to="/prompts-bundle"
                  className="block px-4 py-3 text-sm text-[#ffffffcc] hover:text-white rounded-t-xl transition"
                >
                PROMPT BUNDLE
                </Link> */}

                 <Link
                  to="/workshops"
                  className="block px-4 py-3 text-sm text-[#ffffffcc] hover:text-white rounded-b-xl transition"
                >
                  WORKSHOPS
                </Link>

                 {/* <Link
                  to="/training"
                  className="block px-4 py-3 text-sm hover:bg-white/10 rounded-b-xl transition"
                >
                  TRAINING
                </Link> */}

                <Link
                  to="/store"
                  className="block px-4 py-3 text-sm text-[#ffffffcc] hover:text-white rounded-b-xl transition"
                >
                  STORE
                </Link>

                
              </div>
            </div>
          </nav>

          </div>

          {/* Desktop Login/Signup (Hidden on mobile) */}
          {
            (user) ?
              <>
                <div className="flex gap-3 items-center relative">
                  {/* <Link to="/notifications" className="hidden lg:block relative">
                    <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
                    <span className="absolute -top-3 -right-2 bg-red-500 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
                      5
                    </span>
                  </Link> */}
                  <div className="hidden lg:block relative top-1">
                    <NotificationPopup />
                  </div>
                  {/* {
                    (userData && userData?.image)
                      ?
                      <Link to="/my-profile">
                        <img src={IMAGE_URL + userData?.image || '/favicon.png'}
                          onError={(e) => e.target.src = '/favicon.png'}
                          className="w-8 h-8 rounded-full border shadow hidden lg:block" title="Profile" />
                      </Link>
                      :
                      <Link to="/my-profile" className="hover:text-blue-500 hidden lg:flex items-center gap-2">
                        <CgProfile className="text-xl w-7 h-7" />
                      </Link>
                  } */}
                   <div className="relative hidden lg:block user-menu" ref={drawerRef}>
                <button onClick={toggleDrawer} className="hamburger-menu" aria-label="Toggle menu">
                  <div className="w-6 h-4 flex flex-col justify-between">
                    <span className="w-full h-0.5 bg-white rounded"></span>
                    <span className="w-full h-0.5 bg-white rounded"></span>
                    <span className="w-full h-0.5 bg-white rounded"></span>
                  </div>
                </button>
              </div>


                </div>
              </>
              :
              <>
                <div className="hidden lg:flex items-center space-x-4">
                  <Link
                  to="/login"
                  className="
                    group
                    inline-flex items-center justify-center gap-2
                    px-4 py-2
                    rounded-full
                    text-white
                    bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                    hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)]
                    transition-all duration-300
                    shadow-lg
                    text-[15px]
                    font-bold
                    uppercase
                  "
                >
                  Join Free

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-5 h-5 transition-transform group-hover:translate-x-1"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </Link>

                </div>
              </>
          }


          {/* Mobile Right-side Icons (Notification, Search, User) */}
          <div className="lg:hidden flex items-center space-x-4">
            {/* <Link to="/notifications">
              <FiBell className="text-white w-6 h-6 hover:text-blue-500" />
            </Link> */}
            {/* <Link to="/search">
              <FiSearch className="text-white w-6 h-6 hover:text-blue-500" />
            </Link> */}

            {
              (user) ?
                <>
                  {/* <div className="flex items-center gap-3">
                  <div className=" lg:hidden relative top-0.5">
                    <NotificationPopup />
                  </div>
                  {
                    (userData && userData?.image) ?
                      <Link to="/my-profile">
                        <img src={IMAGE_URL + userData?.image} className="w-8 h-8 rounded-full border shadow" title="Profile" />
                      </Link>
                      :
                      <Link to="/my-profile">
                        <FiUser className="text-white w-8 h-8 hover:text-blue-500" title="Profile" />
                      </Link>
                  }

                </div> */}
                  <div className="relative user1-menu" ref={drawerRef}>
                    <button onClick={toggleDrawer} className="hamburger-menu" aria-label="Toggle menu">
                      <div className="w-6 h-4 flex flex-col justify-between">
                        <span className="w-full h-0.5 bg-white rounded"></span>
                        <span className="w-full h-0.5 bg-white rounded"></span>
                        <span className="w-full h-0.5 bg-white rounded"></span>
                      </div>
                    </button>
                  </div>
                </>
                :
                <>
                  {/* <Link to="/login">
                  <FiUser className="text-white w-8 h-8 hover:text-blue-500" title="Profile" />
                </Link> */}
                  <Link
                  to="/login"
                  className="
                    group
                    inline-flex items-center justify-center gap-2
                    px-4 py-2
                    rounded-full
                    text-white
                    text-[15px] font-bold uppercase
                    bg-[linear-gradient(45deg,#d54d09,#e1307a,#9443ff,#436cff)]
                    hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)]
                    transition-all duration-300
                    shadow-lg
                  "
                >
                  Join Free

                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    className="w-5 h-5 transition-transform group-hover:translate-x-1"
                  >
                    <path d="M5 12h14" />
                    <path d="m12 5 7 7-7 7" />
                  </svg>
                </Link>

                </>
            }

          </div>
        </div>


        <div
          className={`fixed inset-0 z-50 flex justify-end transition-opacity duration-350 ${showDrawer ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        >
          <div
            className={`fixed inset-0 bg-black transition-opacity duration-350 ${showDrawer ? "bg-opacity-60" : "bg-opacity-0"}`}
            onClick={closeDrawer}
          ></div>
          {/* bg-background-back2 */}
          <div
            className={`drawer w-64 bg-[#0a0a0a] text-white shadow-lg transform transition-all duration-350 ease-[cubic-bezier(0.25,0.1,0.25,1)] ${showDrawer ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
            ref={drawerRef}
          >
            <div className="flex items-center px-2 py-4 border-b border-[#484848]">
              <div className="flex items-center gap-2">
                {userData?.image ? (
                  <img
                    src={IMAGE_URL + userData.image}
                    onError={(e) => (e.target.src = "/favicon.png")}
                    className="w-10 h-10 rounded-full border shadow"
                    alt="Profile"
                  />
                ) : (
                  <Avatar name={userData?.name} size="40" round={true} />
                )}
                <div className="flex flex-col">
                  <span className="text-[14px] font-semibold text-white">{userData?.name || ""}
                    {
                      (userData.isMembership === true) && <>
                        <div title="Premium" className="bg-black ml-2 inline-flex items-center gap-1 px-1 py-1  bg1-gradient-to-r from-yellow-400 to-yellow-500  text-white text-sm font-semibold rounded shadow-md">
                          <FaCrown size={12} className="text-yellow-400" />
                        </div>
                      </>
                    }

                  </span>
                  <span className="text-[12px] text-gray-400">{userData?.email || ""} </span>
                </div>

              </div>

              <button onClick={closeDrawer} className="ml-auto text-gray-400 hover:text-white">
                <div className="text-white bg-[#515151] flex items-center hover:bg-background-primary h-5 w-5 md:h-8 md:w-8 p-[2px] relative top-[-18px] md:top-[-10px] rounded-full text-[10px]">
                  <AiOutlineClose className="h-3 w-3 md:h-4 md:w-4 m-auto" />
                </div>
              </button>
            </div>

            <nav className="flex flex-col">
              <Link
                to="/my-profile"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/my-profile" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FiEdit className="text-[16px]" />
                My Profile
              </Link>

              {/* <Link
                to="/my-purchase-prompts"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/my-purchase-prompts" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FiEdit className="text-[16px]" />
                My Purchase Bundle
              </Link> */}

              <Link
                to="/coupons"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/coupons" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <BiSolidOffer className="text-[16px]" />
                Coupons
              </Link>

              <Link
                to="/about-us"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/about-us" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FiInfo className="text-[16px]" />
                About Us
              </Link>

              <Link
                to="/terms"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/terms" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FiFileText className="text-[16px]" />
                Terms
              </Link>

              <Link
                to="/privacy"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/privacy" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FiInfo className="text-[16px]" />
                Privacy & Policies
              </Link>

              <button
                className="mx-4 mt-4 inline-block border-2 border-customBlue flex justify-center px-1 py-1 w-auto custom-back rounded-full text-white hover:bg-[linear-gradient(45deg,#ff7a18,#ff0066,#9b30ff,#3a7bd5)] transition text-[12px] md:text-[16px] font-bold my-2"
                onClick={() => setShowLogoutConfirm(true)}
              >
                <FiLogOut className="mr-2 w-5 h-5" />
                Logout
              </button>



              {/* <Link
                to="/video-prompts"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/video-prompts" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FaVideo className="text-[16px]" />
                Video Prompts
              </Link>
              <Link
                to="/my-profile"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/my-profile" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <MdOutlinePsychologyAlt className="text-[16px]" />
                My Prompts
              </Link>
              <Link
                to="/courses"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/courses" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <FaBookOpen className="text-[16px]" />
                AI Courses
              </Link>
              <Link
                to="/news"
                className={`flex items-center gap-2 px-4 py-3 border-b border-[#484848] text-[14px] md:text-[16px] ${currentPath === "/news" ? " text-primary" : " hover:text-primary"}`}
                onClick={closeDrawer}
              >
                <BsCalendarCheck className="text-[16px]" />
                AI News
              </Link>
              <button
                className="mx-4 mt-4 inline-block border-2 border-customBlue flex justify-center px-1 py-1 w-auto custom-back rounded text-white hover:bg-background-primary transition text-[12px] md:text-[16px] font-bold my-2"
                onClick={() => setShowLogoutConfirm(true)}
              >
                <FiLogOut className="mr-2 w-5 h-5" />
                Logout
              </button> */}
            </nav>
          </div>
        </div>

        <style jsx>{`
          .drawer {
            height: 100vh;
            overflow-y: auto;
            will-change: transform, opacity;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
          }
          .drawer a {
            transition: background-color 0.2s ease, color 0.2s ease;
          }
          .hamburger-menu {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            background: #515151;
            border-radius: 8px;
            transition: background-color 0.2s ease;
          }
          .hamburger-menu:hover {
            background: #2563eb;
          }
        `}</style>


       {showLogoutConfirm &&
  createPortal(
      <div className="fixed inset-0 bg-black/40 backdrop-blur-md flex items-start justify-center pt-28 z-[9999]">
  <div className="w-[360px] rounded-2xl border border-white/10 bg-background-back2 p-7 shadow-2xl text-center">

    {/* Icon Circle */}
    <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full 
    bg-gradient-to-tr from-[#ff7a18] via-[#e1307a] to-[#436cff] text-white text-xl font-bold">
      ?
    </div>

    {/* Title */}
    <h3 className="text-xl font-semibold text-white">
      Are you sure?
    </h3>

    {/* Description */}
    <p className="text-sm text-gray-300 mt-2 mb-6">
      Do you really want to log out from your account?
    </p>

    {/* Buttons */}
    <div className="flex gap-3">
      <button
        onClick={() => setShowLogoutConfirm(false)}
        className="flex-1 py-2 rounded-lg border border-white/20 
        text-white hover:bg-white/10 transition font-semibold"
      >
        Cancel
      </button>

      <button
        onClick={handleLogout}
        className="flex-1 py-2 rounded-lg font-semibold text-white 
        bg-gradient-to-r from-[#ff7a18] via-[#e1307a] to-[#436cff] 
        hover:opacity-90 transition shadow-lg"
      >
        Logout
      </button>
    </div>

  </div>
</div>,
      document.body
  )
}
      </header>
    </>
  );
};

export default SiteHeader;